import { useEffect, useState } from "react";
import { Empty } from "antd";
import { mapMarker } from "../../components/common/KakaoMap";

import Skeleton from "antd/es/skeleton/index";
import RunningMap from "../common/RunningMap";

import * as TypeDTO from "../../commons/typeDTO";

const TabRunningMap = ({
    isFinish,
    loadingApiRunningGpsData,
    runningCanGpsDataList,
    chartMarker,
}: {
    isFinish?: boolean;
    loadingApiRunningGpsData?: boolean;
    runningCanGpsDataList?: Array<TypeDTO.DataGpsDto>;
    chartMarker?: mapMarker;
}) => {
    return (
        <>
            {!runningCanGpsDataList ||
                (runningCanGpsDataList.length < 1 && (
                    <div style={{ padding: "24px 16px" }}>
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    </div>
                ))}
            {loadingApiRunningGpsData ? (
                <Skeleton className="skeleton-block" active />
            ) : (
                <RunningMap isMobile isFinish={isFinish} runningPositions={runningCanGpsDataList} marker={chartMarker} />
            )}
        </>
    );
};

export default TabRunningMap;
